import { formatDate } from '@helpers/DateHelper'

export default (date, format, defaultValue, timeZone) =>
  formatDate(date, { format, defaultValue, timeZone })
